module.exports = __webpack_public_path__ + "static/img/earn02.5f738305.webp";